import { createBrowserRouter, Navigate, useNavigate } from "react-router-dom";
import { useState, useMemo } from "react";

import Home from "../Pages/Home";
import Layout from "../component/Layout/Layout";

// Auth Pages
import Login from "../component/Model/Login";
import Register from "../component/Model/Register";

// Dashboard Pages
import DashboardOverview from "../Pages/DashboardOverview";
import DashboardAdmin from "../Pages/DashboardAdmin";
import AdminDashboardOverview from "../Pages/AdminDashboardOverview";
import UserManagementAdmin from "../Pages/UserManagementAdmin";
import TransaksiPage from "../Pages/TransaksiPage";
import OutletPage from "../Pages/OutletPage";
import CategoriesPage from "../Pages/CategoriesPage";
import LaporanPage from "../Pages/LaporanPage";

// Wrapper Sidebar (untuk dashboard)
import Sidebar from "../component/Sidebar";

function DashboardLayout({ children }) {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const sidebarWidth = useMemo(() => (collapsed ? 84 : 260), [collapsed]);
  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };
  const user = JSON.parse(localStorage.getItem("user"));
  if (!user) return <Navigate to="/login" />;

  return (
    <>
      <Sidebar
        active=""
        onLogout={handleLogout}
        role={user.role}
        onNavigate={(path) => navigate(path)}
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed((prev) => !prev)}
      />

      <div
        className="dashboard-shell"
        style={{
          marginLeft: `${sidebarWidth}px`,
          minHeight: "100vh",
          background: "#f8fafc",
          transition: "margin-left 0.2s ease",
        }}
      >
        {children}
      </div>

      <style>{`
        @media (max-width: 991px) {
          .dashboard-shell { margin-left: 0 !important; }
        }
      `}</style>
    </>
  );
}

function AutoDashboardRedirect() {
  const user = JSON.parse(localStorage.getItem("user"));

  if (!user) return <Navigate to="/login" />;

  // Redirect based on role
  if (user.role === "admin") {
    return <Navigate to="/admin/dashboard/overview" />;
  }

  return <Navigate to="/dashboard/overview" />;
}

export const routes = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [{ path: "/", element: <Home /> }],
  },
  { path: "/login", element: <Login /> },
  { path: "/register", element: <Register /> },

  {
    path: "/dashboard",
    element: <AutoDashboardRedirect />,
  },

  // Dashboard Overview (for both admin and user)
  {
    path: "/dashboard/overview",
    element: (
      <DashboardLayout>
        <DashboardOverview />
      </DashboardLayout>
    ),
  },

  {
    path: "/dashboard/admin",
    element: (
      <DashboardLayout>
        <DashboardAdmin />
      </DashboardLayout>
    ),
  },
  {
    path: "/dashboard/admin/users",
    element: (
      <DashboardLayout>
        <UserManagementAdmin />
      </DashboardLayout>
    ),
  },

  {
    path: "/dashboard/user/transaksi",
    element: (
      <DashboardLayout>
        <TransaksiPage />
      </DashboardLayout>
    ),
  },
  {
    path: "/dashboard/user/outlet",
    element: (
      <DashboardLayout>
        <OutletPage />
      </DashboardLayout>
    ),
  },
  {
    path: "/dashboard/user/categories",
    element: (
      <DashboardLayout>
        <CategoriesPage />
      </DashboardLayout>
    ),
  },
  {
    path: "/dashboard/user/laporan",
    element: (
      <DashboardLayout>
        <LaporanPage />
      </DashboardLayout>
    ),
  },

  {
    path: "/admin/dashboard",
    element: (
      <DashboardLayout>
        <DashboardAdmin />
      </DashboardLayout>
    ),
  },
  {
    path: "/admin/dashboard/overview",
    element: (
      <DashboardLayout>
        <AdminDashboardOverview />
      </DashboardLayout>
    ),
  },
  {
    path: "/admin/users",
    element: (
      <DashboardLayout>
        <UserManagementAdmin />
      </DashboardLayout>
    ),
  },

  // USER
  {
    path: "/transaksi",
    element: (
      <DashboardLayout>
        <TransaksiPage />
      </DashboardLayout>
    ),
  },
  {
    path: "/outlet",
    element: (
      <DashboardLayout>
        <OutletPage />
      </DashboardLayout>
    ),
  },
  {
    path: "/categories",
    element: (
      <DashboardLayout>
        <CategoriesPage />
      </DashboardLayout>
    ),
  },
  {
    path: "/laporan",
    element: (
      <DashboardLayout>
        <LaporanPage />
      </DashboardLayout>
    ),
  },
]);
